import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isListening: false,
  isBotResponding: false,
  showChatLogo: false, // Adjust to true if logo visible by default
};

const animationSlice = createSlice({
  name: 'animation',
  initialState,
  reducers: {
    startListening(state) {
      state.isListening = true;
    },
    stopListening(state) {
      state.isListening = false;
    },
    startBotResponse(state) {
      state.isBotResponding = true;
    },
    stopBotResponse(state) {
      state.isBotResponding = false;
    },
    // New reducer to update the chat logo visibility
    setShowChatLogo(state, action) {
      state.showChatLogo = action.payload;
    },
  },
});

export const {
  startListening,
  stopListening,
  startBotResponse,
  stopBotResponse,
  setShowChatLogo,
} = animationSlice.actions;

export default animationSlice.reducer;
